import type { JSX } from 'react'

export const FavoriteToggleIcon = ({
  filled,
}: {
  filled?: boolean
}): JSX.Element => (
  <g>
    <use
      href='#plusFavoriteIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 0 : 1}
    />
    <use
      href='#selectedFavoriteIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </g>
)
